export default {
    titulos: {
        listagem: 'Importação do MyLogical Lite',
        importar: 'Importar dados',
    },
    tabela: {
        data: 'Data',
        cliente: 'Cliente',
        tipoArquivo: 'Tipo de Arquivo',
        tipoImportacao: 'Tipo de Importação',
        situacao: 'Situação',
        descricao: 'Descrição',
        numeroLinha: 'Número da Linha',
        usuario: 'Usuário',
    },
    modal: {
        titulo: 'Importar dados',
    },
    botoes: {
        visualizar: 'Visualizar importação',
    },
    tipo_importacao: 'Tipo da Importação',
    importacaoSucesso: 'Sucesso na importação',
    validacaoFormulario: 'Preencha todos os dados do formulário',
    validacaoArquivo: 'É necessário inserir um arquivo antes de confirmar',
};